export default __webpack_public_path__ + "static/media/gold_reveal.3e57a1b8.mp3";